import { Controller } from '@hotwired/stimulus';
import ApexCharts from 'apexcharts';

export default class extends Controller {
  static targets = ['purchasesChart', 'subscriptionsChart'];

  connect() {
    if (this.hasPurchasesChartTarget) {
      this.initPurchasesChart();
    }

    if (this.hasSubscriptionsChartTarget) {
      this.initSubscriptionsChart();
    }
  }

  initPurchasesChart() {
    const purchasesData = JSON.parse(this.purchasesChartTarget.dataset.values);
    const purchasesDates = JSON.parse(this.purchasesChartTarget.dataset.dates);

    const options = {
      series: [
        {
          name: 'Purchases',
          data: purchasesData,
        },
      ],
      chart: {
        height: 350,
        type: 'area',
        toolbar: {
          show: false,
        },
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        curve: 'smooth',
        width: 2,
      },
      colors: ['#6366f1'],
      fill: {
        type: 'gradient',
        gradient: {
          shadeIntensity: 1,
          opacityFrom: 0.7,
          opacityTo: 0.2,
          stops: [0, 90, 100],
        },
      },
      xaxis: {
        categories: purchasesDates,
        labels: {
          formatter: function (value) {
            if (!value) return '';
            return value.toString().split('-').slice(1).join('/');
          },
        },
      },
      yaxis: {
        labels: {
          formatter: function (val) {
            if (val === undefined || val === null) return '0';
            return val.toFixed(0);
          },
        },
      },
      tooltip: {
        x: {
          format: 'dd/MM/yy',
        },
      },
    };

    const chart = new ApexCharts(this.purchasesChartTarget, options);
    chart.render();
  }

  initSubscriptionsChart() {
    const subscriptionsData = JSON.parse(
      this.subscriptionsChartTarget.dataset.values
    );
    const subscriptionsDates = JSON.parse(
      this.subscriptionsChartTarget.dataset.dates
    );

    const options = {
      series: [
        {
          name: 'Subscriptions',
          data: subscriptionsData,
        },
      ],
      chart: {
        height: 350,
        type: 'area',
        toolbar: {
          show: false,
        },
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        curve: 'smooth',
        width: 2,
      },
      colors: ['#10b981'],
      fill: {
        type: 'gradient',
        gradient: {
          shadeIntensity: 1,
          opacityFrom: 0.7,
          opacityTo: 0.2,
          stops: [0, 90, 100],
        },
      },
      xaxis: {
        categories: subscriptionsDates,
        labels: {
          formatter: function (value) {
            if (!value) return '';
            return value.toString().split('-').slice(1).join('/');
          },
        },
      },
      yaxis: {
        labels: {
          formatter: function (val) {
            if (val === undefined || val === null) return '0';
            return val.toFixed(0);
          },
        },
      },
      tooltip: {
        x: {
          format: 'dd/MM/yy',
        },
      },
    };

    const chart = new ApexCharts(this.subscriptionsChartTarget, options);
    chart.render();
  }
}
